import {ChangeDetectorRef, Component, ComponentFactoryResolver, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from "../../../../services/common/common-field.service";
import {RecapProfileService} from "../../../../services/archive/recap-profile.service";
import {ProfileAbsComponent} from "../../profile/profile-abs.component";
import {ReportTaskService} from "../../../../services/archive/report-task.service";
import {ReportTask} from "../../../../model/archive/report-task";
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {ReportProfile} from "../../../../model/archive/report-profile";
import {NotificationService} from "../../../../services/security/notification.service";
import {AppConfigService} from "../../../../services/app-config.service";
import {CCRolesType} from "../../../../model/security/cc-roles-type";
import {CcStorageService} from "../../../../services/common/cc-storage.service";
import {UserInfoStorageService} from "../../../../services/auth/user-info-storage.service";
import EXPORT_DATE_MODE = ReportProfile.EXPORT_DATE_MODE;
import EXPORT_FORMAT = ReportProfile.EXPORT_FORMAT;

@Component({
  selector: 'app-archive-recap-profile',
  templateUrl: './recap-profile.component.html',
  styleUrls: ['../../profile/profile-abs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class RecapProfileComponent extends ProfileAbsComponent {

  Origin = ReportTask.Origin;

  constructor(cdref: ChangeDetectorRef,
              commonFieldService: CommonFieldService,
              recapProfileService: RecapProfileService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              reportTaskService: ReportTaskService,
              notificationService: NotificationService,
              appConfigService: AppConfigService,
              storageService: CcStorageService,
              userInfoStorageService: UserInfoStorageService) {
    super(ReportTask.Origin.WEB_RECAP, cdref, componentFactoryResolver, messageService, confirmationService,
      translateService, recapProfileService, reportTaskService, notificationService, commonFieldService, appConfigService, storageService,
      userInfoStorageService);
    this.transPartKey = 'profile.recap';
    this.newRecord.differential = true;
    this.newRecord.ignoreEmpty = true;
    this.newRecord.exportDateMode = EXPORT_DATE_MODE.CURRENT_DAY;
    this.newRecord.exportFormat = EXPORT_FORMAT.XLS;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  protected initConfigs() {
    super.initConfigs();
    // this.reportGroupFields.push({
    //   field: 'differential',
    //   column: 2,
    //   type: TYPE.CHECKBOX,
    // });
  }

  protected postInitConfigs() {
    queueMicrotask(() => {
      super.postInitConfigs();

      if (this.isAdmin()) {
        this.headerButtonConfig.push(
          {
            // tooltip: this.translateService.instant('page.' + this.transPartKey + '.table.sync_profiles_button'),
            icon: 'fas fa-wand-sparkles',
            class: ' p-button-info',
            tooltip: this.translateService.instant('page.' + this.transPartKey + '.table.generate_from_old_recaps'),
            enabled: () => true,
            items: [
              {
                icon: 'fas fa-wand-sparkles',
                label: this.translateService.instant('page.' + this.transPartKey + '.table.sync_templates_button'),
                command: records => this.syncTemplatesWithExporter(),
              }, {
                icon: 'fas fa-hat-wizard',
                label: this.translateService.instant('page.' + this.transPartKey + '.table.sync_profiles_button'),
                command: records => this.syncProfilesWithExporter(),
              },
              {
                icon: 'fas fa-hand-sparkles',
                label: this.translateService.instant('page.' + this.transPartKey + '.table.generate_test_profiles_from_templates_button'),
                command: records => this.generateTestProfilesFromTemplates(),
              }]
          },
        );
      }
    });

  }

  syncProfilesWithExporter() {
    (this.crudService as RecapProfileService).syncProfilesWithExporter().subscribe(apiValidation => {
      if (apiValidation.success) {
        this.loadRecords()
      } else {
        this.errorMessage(apiValidation.message);
        this.tableLoading = false;
      }
    });
  }

  syncTemplatesWithExporter() {
    (this.crudService as RecapProfileService).syncTemplatesWithExporter().subscribe(apiValidation => {
      if (apiValidation.success) {
        this.loadRecords()
      } else {
        this.errorMessage(apiValidation.message);
        this.tableLoading = false;
      }
    });
  }

  generateTestProfilesFromTemplates() {
    (this.crudService as RecapProfileService).generateTestProfilesFromTemplates().subscribe(apiValidation => {
      if (apiValidation.success) {
        this.loadRecords()
      } else {
        this.errorMessage(apiValidation.message);
        this.tableLoading = false;
      }
    });
  }

  protected isProfileGroupAdmin(): boolean {
    return this.hasRoles([CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES_GROUP_ADMIN]);
  }

  protected isProfileScheduleAdmin(): boolean {
    return this.hasRoles([CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES_SCHEDULE_ADMIN]);
  }

  protected isProfileGroupLimited(): boolean {
    return this.hasRoles([CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES_GROUP_LIMITED]);
  }
}
